<template>
    <div
        @mouseleave="show_dropdown = false"
        class="dropdown is-right"
        :class="{'is-active': show_dropdown}">

        <avatar @click="show_dropdown = !show_dropdown" class="pointer is-32x32"/>

        <div class="dropdown-menu">
            <div class="dropdown-content">
                <router-link :to="{name: 'settings'}" class="dropdown-item">
                    <i class="icon fas fa-cog"></i>Settings
                </router-link>

                <a @click="logout" class="dropdown-item">
                    <i class="icon fas fa-sign-out-alt"></i>
                    Logout
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from '../common/Avatar.vue';

export default {
    name: 'UserAvatar',
    components: { Avatar },
    data() {
        return { show_dropdown: false };
    },
    methods: {
        logout() {
            this.$store.dispatch('user/sign_out').then(() => {
                this.$router.push({ name: 'signin' });
            });
        },
    },
};
</script>

<style scoped>
    .dropdown-menu {
        padding-top: 0.8rem;
    }

    .default {
        opacity: 0.5;
    }
</style>
